export default __webpack_public_path__ + "static/media/shoe.44ddf535.png";